var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            class:
              _vm.mudouEndereco && _vm.mudouEndereco.mudouLogadouro
                ? "text"
                : "",
            attrs: {
              label: "Logradouro:",
              content: _vm.endereco.logradouro || "-"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _vm.endereco.numero !== "-"
            ? _c("app-display", {
                class:
                  _vm.mudouEndereco && _vm.mudouEndereco.mudouNumero
                    ? "text"
                    : "",
                attrs: {
                  label: "Número:",
                  content: _vm.getValueNumero(_vm.endereco.numero)
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            class:
              _vm.mudouEndereco && _vm.mudouEndereco.mudouBairro ? "text" : "",
            attrs: {
              label: "Bairro:",
              content: _vm.endereco.bairro || "-",
              marginTopBottom:
                _vm.endereco.complemento !== "" && !!_vm.endereco.complemento
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            class:
              _vm.mudouEndereco && _vm.mudouEndereco.mudouComplemento
                ? "text"
                : "",
            attrs: {
              label: "Complemento:",
              content: _vm.getValue(_vm.endereco.complemento) || "-"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            class:
              _vm.mudouEndereco && _vm.mudouEndereco.mudouCEP ? "text" : "",
            attrs: { label: "CEP:", content: _vm.endereco.cep || "-" }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            class: _vm.mudouEndereco && _vm.mudouEndereco.mudouUF ? "text" : "",
            attrs: {
              label: "UF:",
              content:
                _vm.endereco.municipio.estado ||
                _vm.endereco.municipio.codigoEstado ||
                _vm.endereco.municipio.estadoCod
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            class:
              _vm.mudouEndereco && _vm.mudouEndereco.mudouMunicipio
                ? "text"
                : "",
            attrs: {
              label: "Município:",
              content: _vm.getValue(_vm.endereco.municipio.nome)
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e764f17", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e764f17","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesEndereco.vue
// module id = null
// module chunks = 